export const enum CheckResultType {
  FILE_SUFFIX_NOT_MATCH = 'FILE_SUFFIX_NOT_MATCH',
  NEED_RESOLVE = 'NEED_RESOLVE',
  NO_IMAGE_ERROR = 'NO_IMAGE_ERROR',
}

interface IFileObj {
  file: File,
  image?: HTMLImageElement
}

const ACCEPT_SUFFIX = [
  'JPG', 'JPEG', 'PNG', 'DNG', 'GIF', 'RAW', 'BMP', 'TIFF', 'HEIC', 'HEIF', 'WEBP',
]

export async function checkHandler(fileObj: IFileObj): Promise<{
  type: CheckResultType,
  fileObj: IFileObj,
}> {
  const arr = fileObj.file.name.split('.')
  const fileSuffix = arr[arr.length - 1].toLocaleLowerCase()
  const fileType = fileObj.file.type.split('/')[0]

  return new Promise((resolve, reject) => {

    if (!ACCEPT_SUFFIX.includes(fileSuffix) && fileType !== 'image') {
      // console.warn('fileSuffix', fileSuffix)
      return resolve({ type: CheckResultType.FILE_SUFFIX_NOT_MATCH, fileObj })
    }


    if (!fileObj.image) {
      return resolve({ type: CheckResultType.NO_IMAGE_ERROR, fileObj })
    }

    resolve({ type: CheckResultType.NEED_RESOLVE, fileObj })
  })
}
